import { render, staticRenderFns } from "./PaginaAdminCamposResultados.vue?vue&type=template&id=afe7a456&lang=es"
import script from "./PaginaAdminCamposResultados.vue?vue&type=script&lang=js"
export * from "./PaginaAdminCamposResultados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports